export function setSocialMediaLinks(currentURL, whats, instagram, facebook, instagram_contato, facebook_contato) {
    var whats_message;

    if (currentURL.includes('/pt/')) {
        whats_message = 'https://wa.me/551130444068?text=Ol%C3%A1%2C%20entro%20em%20contato%20atrav%C3%A9s%20do%20website%20da%20IT%20Lab%21';
    } else {
        whats_message = 'https://wa.me/551130444068?text=Hello%2C%20I%20can%20contact%20you%20through%20the%20IT%20Lab%20website%21';
    }

    whats.setAttribute("href", whats_message);

    if (isMobileDevice()) {
        if (isFacebookAppInstalled()) {
            facebook.setAttribute("href", 'fb://facewebmodal/f?href=https://www.facebook.com/ItLabBrasil');
        } else {
            facebook.setAttribute("href", 'https://www.facebook.com/ItLabBrasil');
        }
        instagram.setAttribute("href", 'instagram://user?username=itlabbrasil');


        // Handle contato links based on the conditions you need
        if (facebook_contato) {
            if (isFacebookAppInstalled()) {
                facebook_contato.setAttribute("href", 'fb://facewebmodal/f?href=https://www.facebook.com/ItLabBrasil');
            } else {
                facebook_contato.setAttribute("href", 'https://www.facebook.com/ItLabBrasil');
            }
        }

        if (instagram_contato) {
            instagram_contato.setAttribute("href", 'instagram://user?username=itlabbrasil');
        }
    } else {
        // On non-mobile devices, use web URLs for Instagram and Facebook
        instagram.setAttribute("href", 'https://www.instagram.com/itlabbrasil/');
        facebook.setAttribute("href", 'https://www.facebook.com/ItLabBrasil');

        // Handle contato links based on the conditions you need
        if (facebook_contato) {
            facebook_contato.setAttribute("href", 'https://www.facebook.com/ItLabBrasil');
        }

        if (instagram_contato) {
            instagram_contato.setAttribute("href", 'https://www.instagram.com/itlabbrasil/');
        }
    }
}

// Rest of your utility functions...
function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function isFacebookAppInstalled() {
    return navigator.userAgent.includes("FBAN") || navigator.userAgent.includes("FBAV");
}

// function isInstagramAppInstalled() {
//     return /Instagram/i.test(navigator.userAgent);
// }